import { tenantGateway } from '~/gateways/tenantGateway';
import { MagicUseCase } from './magicUseCase';

export class GetTenantInfoUseCase extends MagicUseCase {
  protected async runLogic() {
    this.getState().user.info = await tenantGateway.getTenantInfo();
  }
}
